import Navbar from "../components/navbar/Navbar";
import { Link } from "react-router";
import OrbDashboard from "../components/home/OrbDashboard";
import TubeInteractiveSection from "../components/home/TubeInteractiveSection";
import {
  HELP_PAGE_EXTENSION,
  VIEWER_PAGE_EXTENSION,
} from "../helpers/constants/Constants";

const Home = () => {
  const futureMilestones = [
    {
      year: "2026",
      title: "Connected Delivery Core",
      description:
        "Unify models, field updates, and technical records into one live project platform.",
    },
    {
      year: "2026",
      title: "mView Academy",
      description:
        "Join mView Academy to enhance your skills and knowledge. Become a certified mView user and unlock new opportunities for career growth.",
    },
    {
      year: "2027",
      title: "Autonomous Workflow Assist",
      description:
        "Automate repetitive tasks so teams can focus on decisions and delivering excellence.",
    },
    {
      year: "2028",
      title: "Predictive Intelligence",
      description:
        "Surface risk before delays appear, with insights in context.",
    },
  ];

  return (
    <div className="home-page">
      <Navbar />
      <main className="home-main">
        <section className="home-hero">
          <div className="home-hero__aurora home-hero__aurora--one" />
          <div className="home-hero__aurora home-hero__aurora--two" />
          <div className="home-hero__grid" />

          <div className="home-hero__content">
            <p className="home-kicker">Built for teams</p>
            <h1>
              mView is where complex infrastructure & workflows become clear,
              connected, and actionable.
            </h1>
            <p className="home-subcopy">
              From design reviews to field execution, mView gives teams one
              visual operating layer for projects that cannot afford
              uncertainty.
            </p>

            <div className="home-hero__actions">
              <Link
                className="home-btn home-btn--solid"
                to={VIEWER_PAGE_EXTENSION || "/"}
              >
                mView Viewer
              </Link>
              {/* <Link
                className="home-btn home-btn--ghost"
                to={HELP_PAGE_EXTENSION || "/"}
              >
                Training Academy
              </Link> */}
              <Link
                className="home-btn home-btn--solid"
                to={HELP_PAGE_EXTENSION}
              >
                Help
              </Link>
            </div>
          </div>

          <div className="home-hero__panel">
            <h2>Why mView</h2>
            <p>
              We are evolving mView into a single live project intelligence
              platform that connects data and teams seamlessly.
            </p>
            <ul>
              <li>
                Removal of fragmented platforms and data silos into a single
                source of truth for project information
              </li>
              <li>
                Connected and managed data libraries orientated around standard
                assets to ensure consistency and accuracy
              </li>
              <li>
                Standardised processes and workflows to ensure compliance and
                reduce risk
              </li>
              <li>
                Improved decision-making through integrated insights and
                analytics
              </li>
            </ul>
          </div>
        </section>

        {/* <section className="home-section home-pillars">
          <div className="home-section__header">
            <p className="home-kicker">What mView delivers</p>
            <h2>One platform. Three advantages.</h2>
          </div>

          <div className="home-pillars__grid">
            <article className="home-card">
              <h3>Visual Clarity</h3>
              <p>
                Understand project context quickly with model-first views that
                keep drawings, data, and status connected.
              </p>
            </article>

            <article className="home-card">
              <h3>Delivery Confidence</h3>
              <p>
                Keep teams aligned through shared workflows, transparent
                updates, and practical issue visibility.
              </p>
            </article>

            <article className="home-card">
              <h3>Continuous Improvement</h3>
              <p>
                Learn from every project and feed that intelligence forward into
                safer, faster execution.
              </p>
            </article>
          </div>
        </section> */}

        <section className="home-section home-orb-section">
          <div className="home-section__header">
            <p className="home-kicker">Interactive vision</p>
            <h2>mView Release 1 Features for 2026-27</h2>
          </div>

          <div className="home-orb-showcase">
            <OrbDashboard />
          </div>
        </section>

        <TubeInteractiveSection />

        <section className="home-section home-roadmap">
          <div className="home-section__header">
            <p className="home-kicker">Where we are headed</p>
            <h2>The next chapter of mView</h2>
          </div>

          <div className="home-roadmap__track">
            {futureMilestones.map((milestone) => (
              <article
                className="home-roadmap__item"
                key={`${milestone.year}-${milestone.title}`}
              >
                <span className="home-roadmap__year">{milestone.year}</span>
                <h3>{milestone.title}</h3>
                <p>{milestone.description}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;
